import { FormInputField } from '../../contracts/form-input-field.js';
import { isSameData, isSameList } from '../../models/dto/data-model-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';


export class FormQuestionsComponent extends Component {
  static readonly TYPE_ID: string = '08fa3fc84e294f3894d43d162eeb3fc2';

  constructor(
    public readonly questions: FormInputField[],
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return FormQuestionsComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FormQuestionsComponent {
    return new FormQuestionsComponent(
        MapUtils.getList<FormInputField>(map, 'questions', (data) => context.fromData<FormInputField>(data as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'questions': this.questions.map((x) => context.toData(x)),
    };
  }

  clone(): this {
    return new FormQuestionsComponent(
        this.questions.map((x) => x.clone()),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.questions, this.questions, isSameData);
  }
}

export class FormQuestionsComponentBuilder extends DataModelBuilder<FormQuestionsComponent> {
  build(context: SerializationContext, map: SerializedData): FormQuestionsComponent {
    return FormQuestionsComponent.fromMap(context, map);
  }
}
